import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/home/HomePage';
import ListPage from './pages/ListPage';
import DetailPage from './pages/DetailPage';
import ThematicRouteDetail from './pages/ThematicRouteDetail';
import SpecialtiesPage from './pages/SpecialtiesPage';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/list" element={<ListPage />} />
        <Route path="/detail/:id" element={<DetailPage />} />
        <Route path="/route/detail/:id" element={<ThematicRouteDetail />} />
        <Route path="/specialties" element={<SpecialtiesPage />} />
      </Routes>
    </Router>
  );
};

export default App;